<aside class="aside-seller" [ngClass]="showside ? 'sidebarslide' : ''">
    <a (click)="showsidebar()" class="asidelg" [routerLink]="['/home']"><img src="assets/images/svg/eq_logo.svg"></a>
    <a (click)="showsidebar()" href="javascript:void(0);" class="asidetoggle">MENU</a>
    <h4 class="fs22 txtdefault mt-0 mb-4 mrhead mt-xs-0"><i (click)="showsidebar()"><svg xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" viewBox="0 0 24 24">
                <g id="Group_14366" data-name="Group 14366" transform="translate(-140 -468)">
                    <path id="back_3_" data-name="back (3)"
                        d="M19.288,10.1H3.973L8.583,5.487A.871.871,0,1,0,7.351,4.255l-6.1,6.1a.871.871,0,0,0,0,1.231l6.1,6.1a.871.871,0,1,0,1.231-1.231L3.973,11.838H19.288a.871.871,0,0,0,0-1.742Z"
                        transform="translate(141.42 469.033)" fill="#1f1d44" />
                    <g id="Rectangle_1447" data-name="Rectangle 1447" transform="translate(140 468)" fill="none"
                        stroke="#707070" stroke-width="1" opacity="0">
                        <rect width="24" height="24" stroke="none" />
                        <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
                    </g>
                </g>
            </svg></i> EB Dashboard</h4>
    <div class="as-avt-wrp">
        <div class="d-table">
            <div class="d-table-cell as-avt align-middle">
                <img src="assets/images/product/as-avt.jpg">
            </div>
            <div class="d-table-cell pl-2 align-middle">
                <h4 class="fs14 wt700 txtdefault">{{ name }} <span class="fs12 textsecondary"></span></h4>
                <p class="mb-0 fs14 txtdefault"><svg xmlns="http://www.w3.org/2000/svg" class="mr-1" width="15.473" height="15.522"
                        viewBox="0 0 15.473 15.522">
                        <g id="np_wallet_1594672_000000" transform="translate(-2.7 -2.5)" opacity="0.8">
                            <path id="Path_2329" data-name="Path 2329"
                                d="M12.977,13.137v-1.8a1.855,1.855,0,0,1,1.846-1.846h2.418V8.17A1.346,1.346,0,0,0,15.9,6.83V6.062a1.75,1.75,0,0,0-1.748-1.748H12.161L10.853,2.5,8.321,4.314H4.432A1.729,1.729,0,0,0,2.7,5.965V16.437a1.586,1.586,0,0,0,1.585,1.585H15.657a1.586,1.586,0,0,0,1.585-1.585V14.983H14.823a1.844,1.844,0,0,1-1.846-1.846Zm1.176-7.843a.767.767,0,0,1,.768.768V6.83h-.964L12.863,5.294ZM12.748,6.83H6.49l4.134-2.974ZM4.432,5.294H6.965L4.824,6.83H4.432a.768.768,0,1,1,0-1.536Z"
                                fill="#5e6a7c" />
                            <path id="Path_2330" data-name="Path 2330"
                                d="M74,49.6H71.042A1.137,1.137,0,0,0,69.9,50.746v1.8a1.137,1.137,0,0,0,1.144,1.144H74a.4.4,0,0,0,.392-.392v-3.3A.387.387,0,0,0,74,49.6Zm-2.337,2.892a.842.842,0,1,1,0-1.683.841.841,0,0,1,.834.849A.817.817,0,0,1,71.663,52.494Z"
                                transform="translate(-56.219 -39.406)" fill="#5e6a7c" />
                        </g>
                    </svg>{{ wallet_amount }}</p>
            </div>
        </div>
    </div>
    <ngb-accordion [closeOthers]="true" #acc="ngbAccordion">
        <ngb-panel>
            <ng-template ngbPanelHeader>
                <div class="d-flex align-items-center justify-content-between">
                    <button class="btn btn-link noarrow" [routerLink]="['/seller/dashboard']">

                        <svg xmlns="http://www.w3.org/2000/svg" width="20.737" height="13.226"
                            viewBox="0 0 20.737 13.226">
                            <path id="np_dashboard_637107_000000"
                                d="M22.77,24.09a8.87,8.87,0,0,0-9.141,8.8c.114,3.2,1.371,3.428,4.113,3.428H28.254c2.743,0,3.657-.457,3.657-3.428A9.164,9.164,0,0,0,22.77,24.09Zm1.713,6.171s-.394.737-.736,1.422-.427.853-.634,1.32a1.232,1.232,0,0,1,0,1.257,1.117,1.117,0,0,1-1.6.457,1.179,1.179,0,0,1-.571-1.6c.229-.343.571-.8,1.143-.685l1.371-2.743c.114-.229.343-.685.914-.343a.542.542,0,0,1,.114.914Zm5.6,2.628h-.571c-.229,0-.457-.343-.571-.571a5.953,5.953,0,0,0-6.17-5.141A5.948,5.948,0,0,0,16.6,32.432a.612.612,0,0,1-.571.571h-.571a.64.64,0,0,1-.571-.685,7.526,7.526,0,0,1,7.884-6.856,7.57,7.57,0,0,1,7.77,6.856c.114.228-.115.57-.458.57Z"
                                transform="translate(-13.126 -23.59)" fill="#5e6a7c" stroke="rgba(0,0,0,0)"
                                stroke-miterlimit="10" stroke-width="1" opacity="0.8" />
                        </svg>

                        Dashboard
                    </button>
                </div>
            </ng-template>
        </ngb-panel>
        <ngb-panel *ngIf="seller_type == 'super'">
            <ng-template ngbPanelHeader>
                <div class="d-flex align-items-center justify-content-between">
                    <button class="btn btn-link noarrow" [routerLink]="['/seller/sub-sellers']">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="15.502" height="15.521" viewBox="0 0 15.502 15.521">
                            <defs>
                                <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1"
                                    gradientUnits="objectBoundingBox">
                                    <stop offset="0" stop-color="#79b7ff" />
                                    <stop offset="1" stop-color="#07f" />
                                </linearGradient>
                            </defs>
                            <path id="np_seller_3109690_000000"
                                d="M34.333,26.9v1.293l-.517-.388v6.468H32.781V27.8l-.517.388V26.9l1.035-.776Zm-3.1,7.373h1.035V29.1H31.229Zm-1.552,0h1.035v-3.88H29.676Zm-1.552,0h1.035V31.427H28.124Zm-9.293,0h8.776V30.909h1.552V29.875h1.552V28.581h.516a7.758,7.758,0,0,0-12.4,5.692Zm7.741-8.278a3.625,3.625,0,1,0-2.56-1.062,3.623,3.623,0,0,0,2.56,1.062Z"
                                transform="translate(-18.831 -18.751)" fill="url(#linear-gradient)" />
                        </svg>
                        Seller Management
                    </button>
                </div>
            </ng-template>
        </ngb-panel>
        <ngb-panel>
            <ng-template ngbPanelHeader>
                <div class="d-flex align-items-center justify-content-between">

                    <button ngbPanelToggle class="btn btn-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15.697" height="18" viewBox="0 0 15.697 18">
                            <path id="np_bag_943843_000000"
                                d="M23.531,17.342l-1.122-9.9a.317.317,0,0,0-.338-.285H20.149V6.217a3.934,3.934,0,0,0-7.869,0V7.16H10.358a.346.346,0,0,0-.338.285L8.9,17.342V17.4a1.907,1.907,0,0,0,1.9,1.9h10.8a1.907,1.907,0,0,0,1.9-1.9c.019,0,.019-.036.019-.054ZM13.4,6.2a2.813,2.813,0,0,1,5.625,0v.944H13.4Zm-.391,5a.979.979,0,1,1,.979-.979A.965.965,0,0,1,13.01,11.2Zm6.408,0a.979.979,0,1,1,.979-.979A.976.976,0,0,1,19.419,11.2Z"
                                transform="translate(-8.398 -1.801)" fill="#5e6a7c" stroke="rgba(0,0,0,0)"
                                stroke-miterlimit="10" stroke-width="1" opacity="0.8" />
                        </svg>
                        My Products
                    </button>
                </div>
            </ng-template>
            <ng-template ngbPanelContent>
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <a [routerLink]="['/seller/mylisting']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">My Listings</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/seller/mylisting/stocks']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">Stock Details</a>
                    </li>
                    <!-- <li class="nav-item">
					<a [routerLink]="['/seller/business-details']"  class="nav-link fs14 textsecondary" href="javascript:void(0);">Business Details</a>
				  </li>
				  <li class="nav-item ">
					<a  [routerLink]="['/seller/bank-details']"  class="nav-link fs14 textsecondary" href="javascript:void(0);">Bank Details</a>
				  </li>				  -->
                </ul>
            </ng-template>
        </ngb-panel>
        <ngb-panel>
            <ng-template ngbPanelHeader>
                <div class="d-flex align-items-center justify-content-between">
                    <button ngbPanelToggle class="btn btn-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17.153" height="11.875"
                            viewBox="0 0 17.153 11.875">
                            <g id="np_payment_2955769_000000" transform="translate(-9.375 -21.875)" opacity="0.8">
                                <path id="Path_8697" data-name="Path 8697"
                                    d="M26.528,23.854a1.98,1.98,0,0,0-1.979-1.979H11.354a1.98,1.98,0,0,0-1.979,1.979v.66H26.528Z"
                                    transform="translate(0 0)" fill="#5e6a7c" />
                                <path id="Path_8698" data-name="Path 8698"
                                    d="M9.375,46.562a1.98,1.98,0,0,0,1.979,1.979H24.549a1.98,1.98,0,0,0,1.979-1.979V40.625H9.375Zm2.639-3.3h1.319a.66.66,0,0,1,0,1.319H12.014a.66.66,0,1,1,0-1.319Zm0,1.979h3.958a.66.66,0,1,1,0,1.319H12.014a.66.66,0,1,1,0-1.319Z"
                                    transform="translate(0 -14.792)" fill="#5e6a7c" />
                            </g>
                        </svg>
                        Wallet and Payment
                    </button>
                </div>
            </ng-template>
            <ng-template ngbPanelContent>
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <a [routerLink]="['/seller/my-wallet']" class="nav-link active fs14 textsecondary"
                            href="javascript:void(0);">My Wallet</a>
                    </li>
                    <!-- <li class="nav-item">
                        <a [routerLink]="['/manage-payment-methods']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">Manage Payment Methods</a>
                    </li> -->
                    <li class="nav-item ">
                        <a [routerLink]="['/seller/transaction-history']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">Transaction History</a>
                    </li>
                </ul>
            </ng-template>
        </ngb-panel>
        <ngb-panel>
            <ng-template ngbPanelHeader>
                <div class="d-flex align-items-center justify-content-between">
                    <button ngbPanelToggle class="btn btn-link ">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15.613" height="16.784"
                            viewBox="0 0 15.613 16.784">
                            <path id="np_box_848942_000000"
                                d="M17.806,7,20.38,8.031l-6.849,3.08-3-1.2Zm4.4,1.763,2.873,1.147-7.276,2.909-2.744-1.1Zm3.4,1.781V20.856L18.2,23.784V13.507ZM10,10.543l3.123,1.25v3.013l1.561.585V12.416l2.732,1.092V23.784L10,20.856Z"
                                transform="translate(-10 -7)" fill="#5e6a7c" opacity="0.8" />
                        </svg> All Orders
                    </button>
                </div>
            </ng-template>
            <ng-template ngbPanelContent>
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <a [routerLink]="['/seller/pending-orders']" class="nav-link  fs14 textsecondary"
                            href="javascript:void(0);">Pending Orders for Acceptance</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/seller/all-bids']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">Bids & Offers</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/seller/bidding-orders']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">Bidding Orders</a>
                    </li>
                    <li class="nav-item ">
                        <a [routerLink]="['/seller/track-my-order']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">Track My Orders</a>
                    </li>
                    <li class="nav-item ">
                        <a [routerLink]="['/seller/order-history']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">Order History</a>
                    </li>
                    <li class="nav-item ">
                        <a [routerLink]="['/seller/order-return']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">Return Orders</a>
                    </li>
                    <!-- <li class="nav-item ">
					<a class="nav-link fs14 textsecondary" href="javascript:void(0);">Document Management</a>
				  </li>			  -->
                </ul>
            </ng-template>
        </ngb-panel>
        <ngb-panel>
            <ng-template ngbPanelHeader>
                <div class="d-flex align-items-center justify-content-between">
                    <button ngbPanelToggle class="btn btn-link ">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="12.973" height="15" viewBox="0 0 12.973 15">
                            <defs>
                                <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1"
                                    gradientUnits="objectBoundingBox">
                                    <stop offset="0" stop-color="#79b7ff" />
                                    <stop offset="1" stop-color="#07f" />
                                </linearGradient>
                            </defs>
                            <path id="np_profile_1594246_000000"
                                d="M46.973,46.595a.406.406,0,0,1-.4.405H34.4a.407.407,0,0,1-.4-.405,6.486,6.486,0,0,1,12.973,0Zm-6.486-7.3a3.649,3.649,0,1,1,3.649-3.649A3.65,3.65,0,0,1,40.486,39.3Z"
                                transform="translate(-34 -32)" fill-rule="evenodd" fill="url(#linear-gradient)" />
                        </svg>

                        Account Profile
                    </button>
                </div>
            </ng-template>
            <ng-template ngbPanelContent>
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <a [routerLink]="['/seller/personal-details']" class="nav-link active fs14 textsecondary"
                            href="javascript:void(0);">Personal Details</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/seller/business-details']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">Business Details</a>
                    </li>
                    <li class="nav-item ">
                        <a [routerLink]="['/seller/bank-details']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">Bank Details</a>
                    </li>
                </ul>
            </ng-template>
        </ngb-panel>
        <ngb-panel>
            <ng-template ngbPanelHeader>
                <div class="d-flex align-items-center justify-content-between">
                    <button ngbPanelToggle class="btn btn-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13.596" height="16.856"
                            viewBox="0 0 13.596 16.856">
                            <path id="np_invoice_1112951_000000"
                                d="M19.566,13c-.24,0-.566.2-.566.435V28.008a2.362,2.362,0,0,0,.24.37l1.022,1.305a.435.435,0,0,0,.7,0l.7-.87.7.87a.435.435,0,0,0,.7,0l.7-.87.7.87a.43.43,0,0,0,.675,0l.7-.87.7.87a.43.43,0,0,0,.675,0l.7-.87.7.87a.435.435,0,0,0,.7,0l.7-.87.7.87a.43.43,0,0,0,.675,0l1.022-1.305a2.8,2.8,0,0,0,.24-.587l0-14.355c0-.24-.326-.435-.566-.435Zm2.7,3.045h6.525a.455.455,0,0,1,.435.457.436.436,0,0,1-.435.435H22.263a.436.436,0,0,1-.435-.435A.455.455,0,0,1,22.263,16.045Zm6.525,8.918H22.263a.476.476,0,0,1-.435-.478.436.436,0,0,1,.435-.435h6.525a.436.436,0,0,1,.435.435A.476.476,0,0,1,28.788,24.963Zm0-2.828H22.263a.476.476,0,0,1-.435-.478.436.436,0,0,1,.435-.435h6.525a.436.436,0,0,1,.435.435A.476.476,0,0,1,28.788,22.135Zm.435-3.045a.427.427,0,0,1-.435.435H22.263a.435.435,0,1,1,0-.87h6.525A.436.436,0,0,1,29.223,19.09Z"
                                transform="translate(-19 -13)" fill="#5e6a7c" opacity="0.8" />
                        </svg>

                        Deal Invoices and Documents
                    </button>
                </div>
            </ng-template>
            <ng-template ngbPanelContent>
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <a class="nav-link fs14 textsecondary" [routerLink]="['/seller/my-invoices']"
                            href="javascript:void(0);">My Invoices</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link fs14 textsecondary"
                            [routerLink]="['/seller/deal-invoice']"
                            href="javascript:void(0);">Deal Invoices</a>
                    </li>
                    <li class="nav-item ">
                        <a class="nav-link fs14 textsecondary"
                            [routerLink]="['/seller/charges-invoice']"
                            href="javascript:void(0);">Charges Invoice</a>
                    </li>
                    <li class="nav-item ">
                        <a class="nav-link fs14 textsecondary"
                            [routerLink]="['/seller/transportation-document']"
                            href="javascript:void(0);">Transportation Document</a>
                    </li>
                </ul>
            </ng-template>
        </ngb-panel>

        <ngb-panel>
            <ng-template ngbPanelHeader>
                <div class="d-flex align-items-center justify-content-between">
                    <button class="btn btn-link noarrow" [routerLink]="['/seller/join-a-candf']">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="19.503" height="13.768" viewBox="0 0 19.503 13.768">
                            <defs>
                                <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1"
                                    gradientUnits="objectBoundingBox">
                                    <stop offset="0" stop-color="#79b7ff" />
                                    <stop offset="1" stop-color="#07f" />
                                </linearGradient>
                            </defs>
                            <path id="Union_20" data-name="Union 20"
                                d="M-2891.472-17847.238a.614.614,0,0,1-.252-.137,1.937,1.937,0,0,1-.208-.2s.313-.314.352-.359a1.9,1.9,0,0,0,.3-.477c.544.666.316.9.226.994a.514.514,0,0,1-.349.184A.326.326,0,0,1-2891.472-17847.238Zm-2.109-.26c-.225-.219.049-.641.289-.93.092-.1.558-.6.646-.7a.727.727,0,0,1,.458-.23.461.461,0,0,1,.308.137.434.434,0,0,1,.17.322,1.183,1.183,0,0,1-.469.8c-.458.451-.812.734-1.1.734A.417.417,0,0,1-2893.581-17847.5Zm-1.35-.859c-.353-.385.28-1.189.5-1.449.041-.045.768-.8.771-.8.264-.271.644-.533.963-.246.19.17.218.279.221.365a1.819,1.819,0,0,1-.572.988c-.07.064-.611.66-.637.691-.286.3-.643.613-.931.615h-.011A.394.394,0,0,1-2894.931-17848.357Zm3.717-.811a1.05,1.05,0,0,0-.311-.471,1.006,1.006,0,0,0-.563-.264,1.265,1.265,0,0,0,.157-.605,1.071,1.071,0,0,0-.4-.762.973.973,0,0,0-1.051-.189,1.406,1.406,0,0,0,.009-.205,1.24,1.24,0,0,0-.489-.941,1.033,1.033,0,0,0-1.185-.121,1.143,1.143,0,0,0,0-.119,1.218,1.218,0,0,0-.589-.846c-.888-.59-1.681.23-2.193.912a13.286,13.286,0,0,1-1.5-1.686,4.575,4.575,0,0,0-.981-1.389c.43-.891,1.428-2.955,1.889-3.846a7.513,7.513,0,0,0,1.6.184,4.376,4.376,0,0,0,1.517-.24,5.29,5.29,0,0,1,.771-.234c-.183.119-.417.256-.68.41-1.277.744-3.026,1.762-2.484,2.918a.944.944,0,0,0,.562.521c.714.246,1.807-.27,3.52-1.148,1.624-.838,3.686,1.5,4.363,2.271.461.52.88,1.082,1.322,1.615,1.36,1.645,1.582,2.123,1.191,2.551a.421.421,0,0,1-.333.146,2.4,2.4,0,0,1-1.306-.822c-.066-.074-.13-.141-.194-.2-.126-.137-.828-.922-1.059-1.152s-.4-.391-.417-.4a.269.269,0,0,0-.384.014.28.28,0,0,0,.014.391s.239.227.5.484c.2.2,1.054,1.152,1.107,1.205.393.436.989,1.266.614,1.678a.463.463,0,0,1-.361.186c-.384,0-.862-.492-1.193-.855-.062-.072-1.134-1.232-1.573-1.709a.267.267,0,0,0-.384-.012.278.278,0,0,0-.012.389c.224.24.615.662.957,1.035.146.158.7.775.763.857.267.348.646.951.356,1.268a.369.369,0,0,1-.287.143C-2890.351-17848.217-2890.908-17848.828-2891.214-17849.168Zm-5.163-.346c-.489-.537-.128-1.037.394-1.635l.121-.143c.431-.5.909-1.008,1.328-1.008a.507.507,0,0,1,.326.123.7.7,0,0,1,.289.529,1.57,1.57,0,0,1-.422.947c-.11.111-.486.52-.487.523-.332.363-.805.846-1.185.848A.475.475,0,0,1-2896.377-17849.514Zm-1.466-1.34a.606.606,0,0,1-.132-.633,4.041,4.041,0,0,1,1.1-1.59.718.718,0,0,1,.936-.154.7.7,0,0,1,.348.465.668.668,0,0,1-.166.5c-.382.459-1.276,1.537-1.811,1.545a.093.093,0,0,1-.023,0A.319.319,0,0,1-2897.843-17850.854Zm10.327-2.9c-.448-.541-.869-1.107-1.335-1.631-.745-.848-3.017-3.424-5.013-2.4-1.253.643-2.55,1.309-3.1,1.117a.409.409,0,0,1-.248-.236c-.326-.691,1.3-1.635,2.264-2.2.344-.2.642-.375.856-.525,1.567-1.119,3.4-.656,4.814-.129a5.948,5.948,0,0,0,3.116.049c.46.885,1.463,2.959,1.893,3.852a4.549,4.549,0,0,0-.981,1.391,7.65,7.65,0,0,1-1.528,1.629C-2886.993-17853.123-2887.245-17853.43-2887.516-17853.756Zm3.842-2.107c-.524-1.094-1.642-3.412-2.061-4.207a.563.563,0,0,1,0-.59.742.742,0,0,1,.648-.336.51.51,0,0,1,.451.328c.17.307.624,1.246,1.062,2.156.31.643.719,1.5,1.009,2.092a.634.634,0,0,1-.269.838.614.614,0,0,1-.288.072A.615.615,0,0,1-2883.674-17855.863Zm-17.992.18a.635.635,0,0,1-.274-.828c.262-.562.62-1.363.928-2,.438-.91.892-1.852,1.07-2.172a.626.626,0,0,1,1.092.023v0a.562.562,0,0,1,0,.59c-.416.791-1.466,3.025-1.97,4.1a.616.616,0,0,1-.559.357A.616.616,0,0,1-2901.666-17855.684Z"
                                transform="translate(2902 17860.998)" fill="url(#linear-gradient)" />
                        </svg>
                        Seller Supplier Panel
                    </button>
                </div>
            </ng-template>
        </ngb-panel>

        <ngb-panel>
            <ng-template ngbPanelHeader>
                <div class="d-flex align-items-center justify-content-between">
                    <button ngbPanelToggle class="btn btn-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14.875" height="17" viewBox="0 0 14.875 17">
                            <g id="np_report_3888336_000000" transform="translate(-6.25)" opacity="0.8">
                                <path id="Path_2331" data-name="Path 2331"
                                    d="M34.375.531A.531.531,0,0,1,34.906,0h4.25a.531.531,0,0,1,.531.531V2.656a.531.531,0,0,1-.531.531h-4.25a.531.531,0,0,1-.531-.531Z"
                                    transform="translate(-23.344)" fill="#5e6a7c" />
                                <path id="Path_2332" data-name="Path 2332"
                                    d="M8.906,6.25H9.969V8.729a.727.727,0,0,0,.744.709h5.95a.727.727,0,0,0,.744-.709V6.25h1.063a2.656,2.656,0,0,1,2.656,2.656V19.531a2.656,2.656,0,0,1-2.656,2.656H8.906A2.656,2.656,0,0,1,6.25,19.531V8.906A2.656,2.656,0,0,1,8.906,6.25ZM10.5,18.469a.531.531,0,0,0,1.063,0V12.094a.531.531,0,0,0-1.063,0ZM13.688,19a.531.531,0,0,1-.531-.531v-4.25a.531.531,0,0,1,1.063,0v4.25A.531.531,0,0,1,13.688,19Zm2.656,0a.531.531,0,0,1-.531-.531V16.344a.531.531,0,0,1,1.062,0v2.125A.531.531,0,0,1,16.344,19Z"
                                    transform="translate(0 -5.188)" fill="#5e6a7c" fill-rule="evenodd" />
                            </g>
                        </svg>
                        Business Reports
                    </button>
                </div>
            </ng-template>
            <ng-template ngbPanelContent>
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <a [routerLink]="['/order-reports']" class="nav-link  fs14 textsecondary"
                            href="javascript:void(0);">Order Report</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/seller-reports']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">Seller Report</a>
                    </li>
                    <li class="nav-item ">
                        <a [routerLink]="['/payment-reports']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">Payment Report</a>
                    </li>
                </ul>
            </ng-template>
        </ngb-panel>
        <ngb-panel>
            <ng-template ngbPanelHeader>
                <div class="d-flex align-items-center justify-content-between">
                    <button ngbPanelToggle class="btn btn-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17.526" height="17.526"
                            viewBox="0 0 17.526 17.526">
                            <path id="np_tax_3953297_000000"
                                d="M18.946,9.135V6.59l3.122,3.122H19.523A.577.577,0,0,1,18.946,9.135Zm3.463,1.731v9.811a1.732,1.732,0,0,1-1.731,1.731H14.329A5.771,5.771,0,0,0,9.712,12.136V7.981a1.732,1.732,0,0,1,1.731-1.731h6.348V9.135a1.732,1.732,0,0,0,1.731,1.731Zm-5.771-.577a.576.576,0,0,0-.577-.577H12.6a.577.577,0,0,0,0,1.154h3.463a.576.576,0,0,0,.577-.577ZM20.1,18.946a.576.576,0,0,0-.577-.577H18.369a.577.577,0,0,0,0,1.154h1.154a.576.576,0,0,0,.577-.577Zm0-2.886a.576.576,0,0,0-.577-.577H18.369a.577.577,0,1,0,0,1.154h1.154a.576.576,0,0,0,.577-.577Zm0-2.886a.576.576,0,0,0-.577-.577H17.215a.577.577,0,0,0,0,1.154h2.308a.576.576,0,0,0,.577-.577Zm-4.617,4.617a4.618,4.618,0,1,1-1.353-3.264A4.615,4.615,0,0,1,15.483,17.792ZM9.135,16.638a.577.577,0,1,0,.577-.577.577.577,0,0,0-.577.577ZM12.6,18.946a.576.576,0,1,0-.169.408.577.577,0,0,0,.169-.408Zm-.167-2.718a.577.577,0,0,0-.82,0L9.3,18.536a.579.579,0,1,0,.82.82l2.308-2.308a.577.577,0,0,0,0-.82Z"
                                transform="translate(-5.75 -5.383)" fill="#5e6a7c" stroke="rgba(0,0,0,0)"
                                stroke-miterlimit="10" stroke-width="1" opacity="0.8" />
                        </svg>Tax Reports
                    </button>
                </div>
            </ng-template>
            <ng-template ngbPanelContent>
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <a [routerLink]="['/gstr-report']" class="nav-link  fs14 textsecondary"
                            href="javascript:void(0);">GSTR Report</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/tds-report']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">TDS Report</a>
                    </li>
                    <li class="nav-item ">
                        <a [routerLink]="['/tcs-report']" class="nav-link fs14 textsecondary"
                            href="javascript:void(0);">TCS Report</a>
                    </li>
                </ul>
            </ng-template>
        </ngb-panel>
        <!-- <ngb-panel>
			<ng-template ngbPanelHeader>
			  <div class="d-flex align-items-center justify-content-between">
				<button ngbPanelToggle class="btn btn-link">
					<svg xmlns="http://www.w3.org/2000/svg" width="15.318" height="14.849" viewBox="0 0 15.318 14.849">
					  <g id="np_ads_3696860_000000" transform="translate(-10 -11.223)" opacity="0.8">
						<path id="Path_8699" data-name="Path 8699" d="M81.7,33.057a2.93,2.93,0,0,0-1.966-2.764v5.524A2.926,2.926,0,0,0,81.7,33.057Z" transform="translate(-56.382 -15.419)" fill="#5e6a7c"/>
						<path id="Path_8700" data-name="Path 8700" d="M14.57,35.1c.106.007.221.016.337.027V29.172c-.117.011-.231.02-.337.027a.376.376,0,0,0-.089.019H12.934a2.93,2.93,0,0,0-.881,5.726l.772,4.689a1.135,1.135,0,1,0,2.24-.366l-.688-4.187h.108a.238.238,0,0,0,.086.019Z" transform="translate(0 -14.512)" fill="#5e6a7c"/>
						<path id="Path_8701" data-name="Path 8701" d="M45.555,23.922a.316.316,0,0,0,.259.128.265.265,0,0,0,.1-.016.318.318,0,0,0,.22-.3V11.543a.321.321,0,0,0-.577-.191c-1.5,2.03-4.509,2.936-6.59,3.233v6.1c2.081.3,5.088,1.2,6.59,3.233Zm-5.77-7.668a.319.319,0,0,1-.045-.635,13.823,13.823,0,0,0,5.132-1.761.32.32,0,0,1,.335.546,14.55,14.55,0,0,1-5.374,1.847.257.257,0,0,1-.048,0Z" transform="translate(-23.419)" fill="#5e6a7c"/>
					  </g>
					</svg>Advertisement & Promotion
				</button>
			  </div>
			</ng-template>
			<ng-template ngbPanelContent>
				<ul class="nav flex-column">
				  <li class="nav-item">
					<a class="nav-link  fs14 textsecondary" href="javascript:void(0);">Option 1</a>
				  </li>
				  <li class="nav-item">
					<a class="nav-link fs14 textsecondary" href="javascript:void(0);">Option 2</a>
				  </li>
				  <li class="nav-item ">
					<a class="nav-link fs14 textsecondary" href="javascript:void(0);">Option 3</a>
				  </li>				 
				</ul>  
			</ng-template>
		</ngb-panel> -->
        <ngb-panel>
            <ng-template ngbPanelHeader>
                <div class="d-flex align-items-center justify-content-between">
                    <button ngbPanelToggle class="btn btn-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16.318" height="16.439"
                            viewBox="0 0 16.318 16.439">
                            <path id="np_assistance_3520521_000000"
                                d="M23.334,20.95A7.655,7.655,0,1,0,20.669,23.5a.41.41,0,0,1,.3-.037l3.248.939-.92-3.154a.343.343,0,0,1,.037-.3Zm-2.628-.207a5.494,5.494,0,0,1-3.848,1.6,5.444,5.444,0,1,1,3.848-1.6Zm-5.819-2.421-1.6,1.614a4.668,4.668,0,0,1,0-6.082l1.6,1.6a2.451,2.451,0,0,0,0,2.872Zm3.416.544,1.6,1.6a4.714,4.714,0,0,1-6.082,0l1.6-1.6a2.418,2.418,0,0,0,1.445.469,2.548,2.548,0,0,0,1.445-.469Zm-2.89-3.942-1.6-1.6a4.668,4.668,0,0,1,6.082,0l-1.6,1.6A2.48,2.48,0,0,0,15.413,14.924Zm5.012-1.07a4.714,4.714,0,0,1,0,6.082l-1.6-1.6a2.451,2.451,0,0,0,0-2.872Zm-2.366,1.84a1.686,1.686,0,1,1-2.384,0,1.643,1.643,0,0,1,1.2-.488,1.744,1.744,0,0,1,1.183.488Z"
                                transform="translate(-8.699 -8.699)" fill="#5e6a7c" stroke="rgba(0,0,0,0)"
                                stroke-miterlimit="10" stroke-width="1" opacity="0.8" />
                        </svg>Assistance
                    </button>
                </div>
            </ng-template>
            <ng-template ngbPanelContent>
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <a class="nav-link  fs14 textsecondary" href="javascript:void(0);"
                            [routerLink]="['/seller/assistance']">Manage Assistance</a>
                    </li>
                    <!-- <li class="nav-item">
					<a class="nav-link fs14 textsecondary" href="javascript:void(0);">Option 2</a>
				  </li>
				  <li class="nav-item ">
					<a class="nav-link fs14 textsecondary" href="javascript:void(0);">Option 3</a>
				  </li>				  -->
                </ul>
            </ng-template>
        </ngb-panel>
        <ngb-panel>
            <ng-template ngbPanelHeader>
                <div class="d-flex align-items-center justify-content-between">
                    <button class="btn btn-link noarrow" (click)="logout()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15.231" height="20.444"
                            viewBox="0 0 15.231 20.444">
                            <g id="np_log-out_738609_000000" opacity="0.8">
                                <path id="Path_2333" data-name="Path 2333"
                                    d="M12.929.319q2.968.749,5.938,1.487c.174.043.18.147.18.287q.006,3.19.016,6.38.008,4.62.017,9.239c0,.185-.041.276-.225.34q-3.349,1.154-6.691,2.326c-.061.021-.123.035-.213.061-.008-.149-.02-.28-.021-.409q-.031-3.31-.062-6.619-.057-5.619-.117-11.238C11.744,1.447,11.73.722,11.719,0h.039c.388.108.778.224,1.171.323Zm-.353,10.475a.4.4,0,0,0,.64-.043.832.832,0,0,0,.1-.863.507.507,0,0,0-.493-.348.976.976,0,0,0-.245.147.862.862,0,0,0,0,1.107Z"
                                    transform="translate(-3.849 0.004)" fill="#5e6a7c" />
                                <path id="Path_2334" data-name="Path 2334"
                                    d="M54.971,7.508c-.173,0-.235.042-.233.232.009,1.213,0,2.426,0,3.64v.41c-.311,0-.626,0-.932-.009-.03,0-.078-.123-.078-.189-.006-.753,0-1.506,0-2.26V6.693c0-.12,0-.214.169-.212,1.18.006,2.361,0,3.542,0h0c.033,0,.067,0,.1.01V7.512H57.3c-.774,0-1.551,0-2.331,0Z"
                                    transform="translate(-50.661 -5.155)" fill="#5e6a7c" />
                                <path id="Path_2335" data-name="Path 2335"
                                    d="M53.136,67.577c.263.011.533,0,.805,0v3.631H56.9V72.26c-.078,0-.119.01-.176.01-1.192,0-2.384,0-3.575,0-.176,0-.217-.055-.216-.225q.008-2.129,0-4.257c0-.166.047-.22.207-.216Z"
                                    transform="translate(-49.863 -53.76)" fill="#5e6a7c" />
                                <path id="Path_2336" data-name="Path 2336"
                                    d="M57.468,39.009a.637.637,0,0,0,.272.394q.889.679,1.772,1.366a.468.468,0,0,0,.73-.156h0a.67.67,0,0,0,.05-.233c.008-.15,0-.3,0-.462a3.187,3.187,0,0,1,1.963.668,3.368,3.368,0,0,1,1.191,1.736,3.364,3.364,0,0,0-3.155-4.347V37.5h0a.477.477,0,0,0-.171-.378.461.461,0,0,0-.6,0c-.23.176-.459.354-.688.53-.363.28-.724.562-1.089.839a.627.627,0,0,0-.272.394v.12Z"
                                    transform="translate(-57.468 -29.444)" fill="#5e6a7c" />
                            </g>
                        </svg>
                        Logout
                    </button>
                </div>
            </ng-template>

        </ngb-panel>

    </ngb-accordion>
</aside>